import React, { useEffect, useLayoutEffect, useState } from "react";
import Loader from "../../../../components/Shared/Loader/Loader";
import NoResults from "../../../../components/Shared/NoResults/NoResultsComponent";
import { utilService } from "../../../../services";
import { availabListService } from "./AvailabilityList.service";
import {
  DataChanged,
  RespAvailabListInterface,
} from "./Models/AvailabilityList.model";
import AvailabilityListCard from "./Models/Components/AvailabilityListCard/AvailabilityListCard";
import "./AvailabilityList.scss";
import dayjs from "dayjs";
import _ from "lodash";
import AvailabListEdit from "./Models/Components/AvailabilityListCard/Components/AvailabListEdit/AvailabListEdit";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";

interface AvailabilityListProps {
  onCancel: () => void;
}

const AvailabilityList: React.FC<AvailabilityListProps> = (props) => {

  const { t } = useTranslation("settings");

  const [pageNo, setPageNo]: [number, Function] = useState(1);
  const [availabilityNextValue, setAvailabilityNextValue]: any = useState("");

  const [isLoaderActive, setLoaderStatus] = useState(true);
  var [availableListData, setAvailableListData]: any = useState([]);
  var [selectedCardData, setSelectedCardData]: any = useState();

  var [cardList, setCardList]: any = useState([]);
  const [isAvailableListCardActive, setIsAvailableListCardActive] =
    useState(true);
  const [isAvailableListEditActive, setIsAvailableListEditActive] =
    useState(false);

  const onCancelClick = () => {
    setIsAvailableListCardActive(true);
    setIsAvailableListEditActive(false);
  };

  useLayoutEffect(() => {
    const subscription = availabListService.refreshAvailabList.subscribe((status: any) => {
      if (status) {
        setCardList([]);
        getAvailabilityListDetails();
      }
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    getAvailabilityListDetails();
  }, []);

  async function getAvailabilityListDetails() {
    setLoaderStatus(true);
    const params: any = getListParams();
    const respAvailabListResult: RespAvailabListInterface =
      await availabListService.getAvailabilityList(params);

    if (
      respAvailabListResult?.isSuccess &&
      respAvailabListResult?.displayAvailabListContainer?.[0]?.data
    ) {
      setAvailabilityNextValue(
        respAvailabListResult?.displayAvailabListContainer?.[0]?.next
      );

      if (pageNo === 1) {
        setAvailableListData(
          _.cloneDeep(
            respAvailabListResult?.displayAvailabListContainer[0].data
          )
        );

        const cardListData = cardList.concat(
          respAvailabListResult?.displayAvailabListContainer?.[0]?.data
        );

        setCardList(parseCardList(cardListData));
      } else {
        setAvailableListData([
          ...cardList,
          ...respAvailabListResult?.displayAvailabListContainer?.[0]?.data,
        ]);

        const cardListData = cardList.concat(
          respAvailabListResult?.displayAvailabListContainer?.[0]?.data
        );

        setCardList(parseCardList(cardListData));
      }

      setPageNo(pageNo + 1);
    } else {
      availabListService.handleErrorResponse();
    }

    setLoaderStatus(false);
  }

  const parseCardList = (cardList: any) => {
    var cardListData = cardList;
    const dayList = ["S", "M", "T", "W", "T", "F", "S"];

    cardListData.forEach((element: any, index: any) => {
      var arr = _.values(element.data);
      var sortedArray = _.orderBy(arr, ["id"], ["asc"]);

      Object.keys(sortedArray).forEach((key, ind) => {
        sortedArray[ind].name = dayList[ind];
      });

      cardListData[index].data = sortedArray;
    });

    cardListData = cardListData.map(function (el: any) {
      var o = Object.assign({}, el);

      o.startDateTime = dayjs(
        new Date(el.startDate + " " + el.data[0].startTime)
      ).format("hh:mm A");

      o.endDateTime = dayjs(
        new Date(el.startDate + " " + el.data[0].endTime)
      ).format("hh:mm A");

      return o;
    });

    return cardListData;
  };

  const onDeleteCard = (deletedCardId: number) => {
    setCardList(cardList.filter((card: any) => card.id !== deletedCardId));
  };

  const getListParams = () => {
    return {
      guid: utilService.getLoggedUserGuid(),
      page: pageNo,
      reg_code: utilService.getNetwork(),
    };
  };

  const onScroll = () => {
    if (pageNo > 1 && !_.isEmpty(availabilityNextValue)) {
      getAvailabilityListDetails();
    }
  };

  return (
    <div>
      {isAvailableListCardActive ? (
        <div className="availability-list-container">

          <div className="availability-back" onClick={props.onCancel}>
            <div className="availability-back-icon icon-back"></div>

            <div className="availability-back-header">
              {t("manageAvailabilityTemplates")}
            </div>

          </div>

          <div className="prev-notes-container">
            {cardList && (
              <div className="notes-list-div">

                {isLoaderActive && (
                  <div className="loader-container">
                    <Loader></Loader>
                  </div>
                )}

                <InfiniteScroll
                  dataLength={cardList.length}
                  className="availability-list-templates"
                  next={() => onScroll()}
                  hasMore={true}
                  loader={<div></div>}
                >
                  {cardList && cardList.length > 0 ? (
                    cardList.map((item: DataChanged, index: number) => {
                      return (
                        <AvailabilityListCard
                          key={index}
                          availableListData={item}
                          isCardActive={() => {
                            setIsAvailableListCardActive(true);
                          }}
                          isCardInactive={() => {
                            setIsAvailableListCardActive(false);
                          }}
                          isEditActive={(cardData: any) => {
                            setIsAvailableListEditActive(true);
                            setSelectedCardData(cardData);
                          }}
                          isEditInactive={() => {
                            setIsAvailableListEditActive(false);
                          }}
                          onDeleteCard={onDeleteCard}
                        />
                      );
                    })
                  ) : (
                    !isLoaderActive && (
                      <span>
                        <NoResults></NoResults>
                      </span>
                    )
                  )}
                </InfiniteScroll>

              </div>
            )}
          </div>

        </div>
      ) : (
        <div>
          {isAvailableListEditActive && (
            <AvailabListEdit
              onCancel={onCancelClick}
              availableListCardData={selectedCardData}
              loadData={availableListData}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default AvailabilityList;